import PT from 'prop-types';
import React, { Fragment } from 'react';

import { useIntl } from 'react-intl';

import Divider from '../Divider/Divider';
import FlexLayout from '../FlexLayout/FlexLayout';
import PageLayout from '../PageLayout/PageLayout';
import Text from '../Text/Text';
import { getStepLabels } from './utils';

function Header({ currentStep, steps, title, onClose, rightContent }) {
  const intl = useIntl();
  const labels = getStepLabels(intl);
  const centerContent = (
    <FlexLayout alignItems="center" space={3}>
      {steps.map((step, i) => {
        const isActiveStep = step === currentStep;
        return (
          <Fragment key={step}>
            <Text
              color="gray-800"
              disabled={!isActiveStep}
              variant={isActiveStep ? 's-dense-bold' : 's-dense'}
            >
              {labels[step] || step}
            </Text>
            {i < steps.length - 1 && <Divider width="m" />}
          </Fragment>
        );
      })}
    </FlexLayout>
  );
  return (
    <PageLayout.Header
      centerContent={centerContent}
      title={title}
      onClose={onClose}
      rightContent={rightContent}
    />
  );
}

Header.propTypes = {
  /** Current step */
  currentStep: PT.string,
  /** Steps */
  steps: PT.arrayOf(PT.string.isRequired).isRequired,
  /** Page title */
  title: PT.shape({
    text: PT.string.isRequired,
    maxWidth: PT.number,
  }).isRequired,
  /** Renders an optional close icon on the right */
  onClose: PT.func,
};

export default Header;
